export const GET_CHAT_GROUP_BY_ID_START = 'GET_CHAT_GROUP_BY_ID_START';
export const GET_CHAT_GROUP_BY_ID_SUCCESS = 'GET_CHAT_GROUP_BY_ID_SUCCESS';
export const GET_CHAT_GROUP_BY_ID_FAIL = 'GET_CHAT_GROUP_BY_ID_FAIL';

export const GET_CHATS_START = 'GET_CHATS_START';
export const GET_CHATS_SUCCESS = 'GET_CHATS_SUCCESS';
export const GET_CHATS_FAIL = 'GET_CHATS_FAIL';

export const CREATE_CHAT_GROUP_START = 'CREATE_CHAT_GROUP_START';
export const CREATE_CHAT_GROUP_SUCCESS = 'CREATE_CHAT_GROUP_SUCCESS';
export const CREATE_CHAT_GROUP_FAIL = 'CREATE_CHAT_GROUP_FAIL';

export const CREATE_CHAT_TOPIC_START = 'CREATE_CHAT_TOPIC_START';
export const CREATE_CHAT_TOPIC_SUCCESS = 'CREATE_CHAT_TOPIC_SUCCESS';
export const CREATE_CHAT_TOPIC_FAIL = 'CREATE_CHAT_TOPIC_FAIL';

export const UPDATE_CHAT_GROUP_BY_ID_START = 'UPDATE_CHAT_GROUP_BY_ID_START';
export const UPDATE_CHAT_GROUP_BY_ID_SUCCESS = 'UPDATE_CHAT_GROUP_BY_ID_SUCCESS';
export const UPDATE_CHAT_GROUP_BY_ID_FAIL = 'UPDATE_CHAT_GROUP_BY_ID_FAIL';

export const UPDATE_CHAT_GROUP_AUTHOR_START = 'UPDATE_CHAT_GROUP_AUTHOR_START';
export const UPDATE_CHAT_GROUP_AUTHOR_SUCCESS = 'UPDATE_CHAT_GROUP_AUTHOR_SUCCESS';
export const UPDATE_CHAT_GROUP_AUTHOR_FAIL = 'UPDATE_CHAT_GROUP_AUTHOR_FAIL';

export const UPDATE_CHAT_GROUP_USERS_START = 'UPDATE_CHAT_GROUP_USERS_START';
export const UPDATE_CHAT_GROUP_USERS_SUCCESS = 'UPDATE_CHAT_GROUP_USERS_SUCCESS';
export const UPDATE_CHAT_GROUP_USERS_FAIL = 'UPDATE_CHAT_GROUP_USERS_FAIL';

export const DELETE_CHAT_GROUP_USER_START = 'DELETE_CHAT_GROUP_USER_START';
export const DELETE_CHAT_GROUP_USER_SUCCESS = 'DELETE_CHAT_GROUP_USER_SUCCESS';
export const DELETE_CHAT_GROUP_USER_FAIL = 'DELETE_CHAT_GROUP_USER_FAIL';

export const DELETE_CHAT_GROUP_BY_ID_START = 'DELETE_CHAT_GROUP_BY_ID_START';
export const DELETE_CHAT_GROUP_BY_ID_SUCCESS = 'DELETE_CHAT_GROUP_BY_ID_SUCCESS';
export const DELETE_CHAT_GROUP_BY_ID_FAIL = 'DELETE_CHAT_GROUP_BY_ID_FAIL';

export const SEARCH_USERS_START = 'SEARCH_USERS_START';
export const SEARCH_USERS_SUCCESS = 'SEARCH_USERS_SUCCESS';
export const SEARCH_USERS_FAIL = 'SEARCH_USERS_FAIL';

export const GET_MESSAGES_START = 'GET_MESSAGES_START';
export const GET_MESSAGES_SUCCESS = 'GET_MESSAGES_SUCCESS';
export const GET_MESSAGES_FAIL = 'GET_MESSAGES_FAIL';

// Paginated messages loading
export const GET_MESSAGES_PAGINATED_START = 'GET_MESSAGES_PAGINATED_START';
export const GET_MESSAGES_PAGINATED_SUCCESS = 'GET_MESSAGES_PAGINATED_SUCCESS';
export const GET_MESSAGES_PAGINATED_FAIL = 'GET_MESSAGES_PAGINATED_FAIL';

export const LOAD_MORE_MESSAGES_START = 'LOAD_MORE_MESSAGES_START';
export const LOAD_MORE_MESSAGES_SUCCESS = 'LOAD_MORE_MESSAGES_SUCCESS';
export const LOAD_MORE_MESSAGES_FAIL = 'LOAD_MORE_MESSAGES_FAIL';

export const GET_USERS_IN_CHAT_START = 'GET_USERS_IN_CHAT_START';
export const GET_USERS_IN_CHAT_SUCCESS = 'GET_USERS_IN_CHAT_SUCCESS';
export const GET_USERS_IN_CHAT_FAIL = 'GET_USERS_IN_CHAT_FAIL';

export const CHECK_NEW_MESSAGE_START = 'CHECK_NEW_MESSAGE_START';
export const CHECK_NEW_MESSAGE_SUCCESS = 'CHECK_NEW_MESSAGE_SUCCESS';
export const CHECK_NEW_MESSAGE_FAIL = 'CHECK_NEW_MESSAGE_FAIL';

export const GET_USERS_START = 'GET_USERS_START';
export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS';
export const GET_USERS_FAIL = 'GET_USERS_FAIL';

export const CHANGE_STATUS_CHAT_START = 'CHANGE_STATUS_CHAT_START';
export const CHANGE_STATUS_CHAT_SUCCESS = 'CHANGE_STATUS_CHAT_SUCCESS';
export const CHANGE_STATUS_CHAT_FAIL = 'CHANGE_STATUS_CHAT_FAIL';

export const GET_CHAT_TOPICS_START = 'GET_CHAT_TOPICS_START';
export const GET_CHAT_TOPICS_SUCCESS = 'GET_CHAT_TOPICS_SUCCESS';
export const GET_CHAT_TOPICS_FAIL = 'GET_CHAT_TOPICS_FAIL';

export const CHECK_CHAT_IN_TRACK_START = 'CHECK_CHAT_IN_TRACK_START';
export const CHECK_CHAT_IN_TRACK_SUCCESS = 'CHECK_CHAT_IN_TRACK_SUCCESS';
export const CHECK_CHAT_IN_TRACK_FAIL = 'CHECK_CHAT_IN_TRACK_FAIL';

export const CREATE_MINI_GROUP_START = 'CREATE_MINI_GROUP_START';
export const CREATE_MINI_GROUP_SUCCESS = 'CREATE_MINI_GROUP_SUCCESS';
export const CREATE_MINI_GROUP_FAIL = 'CREATE_MINI_GROUP_FAIL';

export const GET_MINI_GROUP_START = 'GET_MINI_GROUP_START';
export const GET_MINI_GROUP_SUCCESS = 'GET_MINI_GROUP_SUCCESS';
export const GET_MINI_GROUP_FAIL = 'GET_MINI_GROUP_FAIL';

export const UPDATE_MINI_GROUP_START = 'UPDATE_MINI_GROUP_START';
export const UPDATE_MINI_GROUP_SUCCESS = 'UPDATE_MINI_GROUP_SUCCESS';
export const UPDATE_MINI_GROUP_FAIL = 'UPDATE_MINI_GROUP_FAIL';

export const DELETE_MINI_GROUP_START = 'DELETE_MINI_GROUP_START';
export const DELETE_MINI_GROUP_SUCCESS = 'DELETE_MINI_GROUP_SUCCESS';
export const DELETE_MINI_GROUP_FAIL = 'DELETE_MINI_GROUP_FAIL';

export const GET_BREAKOUT_REPORT_START = 'GET_BREAKOUT_REPORT_START';
export const GET_BREAKOUT_REPORT_SUCCESS = 'GET_BREAKOUT_REPORT_SUCCESS';
export const GET_BREAKOUT_REPORT_FAIL = 'GET_BREAKOUT_REPORT_FAIL';

export const CREATE_BREAKOUT_REPORT_START = 'CREATE_BREAKOUT_REPORT_START';
export const CREATE_BREAKOUT_REPORT_SUCCESS = 'CREATE_BREAKOUT_REPORT_SUCCESS';
export const CREATE_BREAKOUT_REPORT_FAIL = 'CREATE_BREAKOUT_REPORT_FAIL';

export const UPDATE_BREAKOUT_REPORT_START = 'UPDATE_BREAKOUT_REPORT_START';
export const UPDATE_BREAKOUT_REPORT_SUCCESS = 'UPDATE_BREAKOUT_REPORT_SUCCESS';
export const UPDATE_BREAKOUT_REPORT_FAIL = 'UPDATE_BREAKOUT_REPORT_FAIL';

export const GET_CURRENT_USER_GROUP_ID_START = 'GET_CURRENT_USER_GROUP_ID_START';
export const GET_CURRENT_USER_GROUP_ID_SUCCESS = 'GET_CURRENT_USER_GROUP_ID_SUCCESS';
export const GET_CURRENT_USER_GROUP_ID_FAIL = 'GET_CURRENT_USER_GROUP_ID_FAIL';

export const GET_CHAT_BOTS_START = 'GET_CHAT_BOTS_START';
export const GET_CHAT_BOTS_SUCCESS = 'GET_CHAT_BOTS_SUCCESS';
export const GET_CHAT_BOTS_FAIL = 'GET_CHAT_BOTS_FAIL';

export const SET_SELECTED_USER = 'SET_SELECTED_USER';

export const SET_SELECTED_CHAT_TOPIC = 'SET_SELECTED_CHAT_TOPIC';

export const CLEAR_SEARCH_USERS = 'CLEAR_SEARCH_USERS';

export const ADD_NEW_MESSAGE_IN_CHAT = 'ADD_NEW_MESSAGE_IN_CHAT';

export const CLEAR_MESSAGES = 'CLEAR_MESSAGES';

export const ADD_NEW_GROUP = 'ADD_NEW_GROUP';

export const CLEAR_SELECTED_USER = 'CLEAR_SELECTED_USER';

export const CLEAR_SELECTED_CHAT_TOPIC = 'CLEAR_SELECTED_CHAT_TOPIC';

export const READ_MESSAGES_IN_CHAT = 'READ_MESSAGES_IN_CHAT';

export const ADD_NEW_MESSAGE = 'ADD_NEW_MESSAGE';

export const SET_REPLY_MESSAGE = 'SET_REPLY_MESSAGE';

export const CLEAR_REPLY_MESSAGE = 'CLEAR_REPLY_MESSAGE';

export const CLEAR_GROUPS = 'CLEAR_GROUPS';

export const CLEAR_USERS = 'CLEAR_USERS';

export const SEARCH_GROUPS = 'SEARCH_GROUPS';

export const CLEAR_FOUND_GROUPS = 'CLEAR_SEARCH_GROUPS';

export const CLEAR_PERSONAL_GROUPS = 'CLEAR_PERSONAL_GROUPS';

export const DELETE_CHAT_GROUP = 'DELETE_CHAT_GROUP';

export const UPDATE_CHAT_GROUP = 'UPDATE_CHAT_GROUP';

export const ADD_NEW_PERSONAL_GROUP = 'ADD_NEW_PERSONAL_GROUP';

export const ADD_NEW_CHAT_TOPIC = 'ADD_NEW_CHAT_TOPIC';

export const CHANGE_STATUS_CHAT = 'CHANGE_STATUS_CHAT';

export const ADD_NEW_SYSTEM_MESSAGE = 'ADD_NEW_SYSTEM_MESSAGE';

// Bot settings constants
export const GET_BOT_SYSTEM_PROMPT_START = 'GET_BOT_SYSTEM_PROMPT_START';
export const GET_BOT_SYSTEM_PROMPT_SUCCESS = 'GET_BOT_SYSTEM_PROMPT_SUCCESS';
export const GET_BOT_SYSTEM_PROMPT_FAIL = 'GET_BOT_SYSTEM_PROMPT_FAIL';

export const UPDATE_BOT_SYSTEM_PROMPT_START = 'UPDATE_BOT_SYSTEM_PROMPT_START';
export const UPDATE_BOT_SYSTEM_PROMPT_SUCCESS = 'UPDATE_BOT_SYSTEM_PROMPT_SUCCESS';
export const UPDATE_BOT_SYSTEM_PROMPT_FAIL = 'UPDATE_BOT_SYSTEM_PROMPT_FAIL';

export const GET_BOT_TOOLS_START = 'GET_BOT_TOOLS_START';
export const GET_BOT_TOOLS_SUCCESS = 'GET_BOT_TOOLS_SUCCESS';
export const GET_BOT_TOOLS_FAIL = 'GET_BOT_TOOLS_FAIL';

export const UPDATE_BOT_TOOLS_START = 'UPDATE_BOT_TOOLS_START';
export const UPDATE_BOT_TOOLS_SUCCESS = 'UPDATE_BOT_TOOLS_SUCCESS';
export const UPDATE_BOT_TOOLS_FAIL = 'UPDATE_BOT_TOOLS_FAIL';

export const GET_AVAILABLE_TOOLS_START = 'GET_AVAILABLE_TOOLS_START';
export const GET_AVAILABLE_TOOLS_SUCCESS = 'GET_AVAILABLE_TOOLS_SUCCESS';
export const GET_AVAILABLE_TOOLS_FAIL = 'GET_AVAILABLE_TOOLS_FAIL';

export const GET_BOT_TEMPERATURE_START = 'GET_BOT_TEMPERATURE_START';
export const GET_BOT_TEMPERATURE_SUCCESS = 'GET_BOT_TEMPERATURE_SUCCESS';
export const GET_BOT_TEMPERATURE_FAIL = 'GET_BOT_TEMPERATURE_FAIL';

export const UPDATE_BOT_TEMPERATURE_START = 'UPDATE_BOT_TEMPERATURE_START';
export const UPDATE_BOT_TEMPERATURE_SUCCESS = 'UPDATE_BOT_TEMPERATURE_SUCCESS';
export const UPDATE_BOT_TEMPERATURE_FAIL = 'UPDATE_BOT_TEMPERATURE_FAIL';

// Bot list constants
export const GET_BOTS_LIST_START = 'GET_BOTS_LIST_START';
export const GET_BOTS_LIST_SUCCESS = 'GET_BOTS_LIST_SUCCESS';
export const GET_BOTS_LIST_FAIL = 'GET_BOTS_LIST_FAIL';

// Selected bot constants
export const SET_SELECTED_BOT = 'SET_SELECTED_BOT';
export const CLEAR_SELECTED_BOT = 'CLEAR_SELECTED_BOT';

// Thinking messages constants
export const ADD_THINKING_MESSAGE = 'ADD_THINKING_MESSAGE';
export const REPLACE_THINKING_MESSAGE = 'REPLACE_THINKING_MESSAGE';

// Deprecated thinking constants (for backward compatibility)
export const BOT_THINK = 'BOT_THINK';
export const AGENT_WORKING = 'AGENT_WORKING';
export const NEW_CHAT_BOT = 'NEW_CHAT_BOT';
export const ADD_NEW_MESSAGE_SLOW = 'ADD_NEW_MESSAGE_SLOW';
export const ADD_NEW_MESSAGE_FAST = 'ADD_NEW_MESSAGE_FAST';
export const CLEAR_THINKING_MESSAGES = 'CLEAR_THINKING_MESSAGES';

// Cleanup pending replacements
export const CLEANUP_PENDING_REPLACEMENTS = 'CLEANUP_PENDING_REPLACEMENTS';

// Provider change action

// Token usage constants
export const GET_COMPANY_TOKEN_QUOTA_START = 'GET_COMPANY_TOKEN_QUOTA_START';
export const GET_COMPANY_TOKEN_QUOTA_SUCCESS = 'GET_COMPANY_TOKEN_QUOTA_SUCCESS';
export const GET_COMPANY_TOKEN_QUOTA_FAIL = 'GET_COMPANY_TOKEN_QUOTA_FAIL';

export const UPDATE_COMPANY_TOKEN_QUOTA = 'UPDATE_COMPANY_TOKEN_QUOTA';

export const GET_COMPANY_TOKEN_USAGE_START = 'GET_COMPANY_TOKEN_USAGE_START';
export const GET_COMPANY_TOKEN_USAGE_SUCCESS = 'GET_COMPANY_TOKEN_USAGE_SUCCESS';
export const GET_COMPANY_TOKEN_USAGE_FAIL = 'GET_COMPANY_TOKEN_USAGE_FAIL';

export const PUSH_COMPANY_TOKEN_QUOTA_START = 'PUSH_COMPANY_TOKEN_QUOTA_START';
export const PUSH_COMPANY_TOKEN_QUOTA_SUCCESS = 'PUSH_COMPANY_TOKEN_QUOTA_SUCCESS';
export const PUSH_COMPANY_TOKEN_QUOTA_FAIL = 'PUSH_COMPANY_TOKEN_QUOTA_FAIL';

export const STOP_SWITCHING_LOADING = 'STOP_SWITCHING_LOADING';
